import store from "@/store/index.js";

export default [
  {
    path: "/screener",
    name: "Screener",
    meta: { requiresAuth: true },
    component: () => import("@/views/Screener.vue"),
    beforeEnter: async (to, from, next) => {
      // console.log(to.params.type);
      await store.dispatch("fetchCompanyByDefault");
      next();
    }
  }
];
